import { render, staticRenderFns } from "./MarketView.vue?vue&type=template&id=0fac12dc"
import script from "./MarketView.vue?vue&type=script&lang=js"
export * from "./MarketView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports